// eslint-disable-next-line import/prefer-default-export
export const MAP_EXTERNAL_STORAGE_CONNECT_ERROR_TO_I18N_KEY: Record<string, string> = {
    'You need to reset the password for your Box account': 'passwordRequired',
};
